import axios from 'axios';
const decipher = salt => {
  const textToChars = text => text.split('').map(c => c.charCodeAt(0));
  const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
  return encoded => encoded.match(/.{1,2}/g)
      .map(hex => parseInt(hex, 16))
      .map(applySaltToChar)
      .map(charCode => String.fromCharCode(charCode))
      .join('');
}
var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
var axiosInstance = axios.create({

   baseURL: `https://legrandgroup.autometrics.in/legrand/`


});

axiosInstance.interceptors.request.use(
   (config) => {
     // Retrieve token from localStorage or any secure storage
    var k= localStorage.getItem("k");
    if(k !== "" && k !== undefined && k !== null)
    {
      var userinfo = decode(k);
      var user = JSON.parse(userinfo);
      // console.log("users", user)
    
      const userId = user.usercode;
      if (userId) {
        config.headers.authorization = userId;
      }
    }
    return config;
    
   },
   (error) => {
     // Handle errors
     return Promise.reject(error);
   }
);
 
export default axiosInstance;
